<template lang="pug">
    v-list
        v-subheader Facturas de compra
        v-list-tile( @click="submit( item )" :key="index" v-for="( item, index ) in items" )
            v-list-tile-title {{ item.invoice_number }}
            v-list-tile-sub-title {{ item.created_at }}
</template>

<script>
    export default {
        props: [ 'items' ],
        methods: {
            submit ({ id }) { this.$router.push( '/purchase_invoice/' + id ) }
        },
    }
</script>
